import { ReactNode } from 'react';
import { StyledTableBody } from '~/shared/components/Table/components/styled';

export type TableBodyProps = {
	children: ReactNode | ReactNode[];
};

export const TableBody = ({ children }: TableBodyProps) => <StyledTableBody>{children}</StyledTableBody>;
